function floating() {
  const floating = document.querySelector(".js-floating[data-floating]");
  if (floating) {
    const viewport = document.querySelector(".js-floating-viewport");
    const floatingBottom = document.querySelector(".js-floating-bottom[data-floating-bottom]");
    const targetSection = document.querySelector(".js-floating-hide");

    let options;
    if (document.querySelector("#js-aggregated_hotels-show") || document.querySelector("#js-hotels")) {
      options = { rootMargin: "0% 0%" };
    } else if (document.querySelector(".SmartView #js-restaurants")) {
      options = { rootMargin: "-50% 0%" };
    } else {
      options = { rootMargin: "0% 0% -100% 0%" };
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          floating.classList.add("c-floating--active");
          if (floatingBottom) floatingBottom.classList.add("c-floating--active");
        } else {
          floating.classList.remove("c-floating--active");
          if (floatingBottom) floatingBottom.classList.remove("c-floating--active");
        }
      });
    }, options);

    if (viewport) observer.observe(viewport);

    // 指定した範囲内で非表示にする
    const hiddenObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            floating.classList.remove("c-floating--active");
            if (floatingBottom) floatingBottom.classList.remove("c-floating--active");
          } else {
            floating.classList.add("c-floating--active");
            if (floatingBottom) floatingBottom.classList.add("c-floating--active");
          }
        });
      },
      { rootMargin: "-50% 0% 0% 0%" },
    );
    if (targetSection) hiddenObserver.observe(targetSection);
  }
}

export { floating };
